import { isFlowEditorNewlyAddedStepId } from 'src/constants/flowEditorFeatureFlags'

export function mintFlowEditorLocalId(prefix: 'step' | 'cfg'): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return prefix === 'step' ? `new-${crypto.randomUUID()}` : crypto.randomUUID()
  }

  return prefix === 'step'
    ? `new-${Date.now()}-${Math.random().toString(16).slice(2)}`
    : `new-cfg-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

/** True when the entity exists on the server (not a client-only id). */
export function isPersistedServerId(serverId: string | undefined | null): boolean {
  if (serverId === null || serverId === undefined) {
    return false
  }

  const trimmed = String(serverId).trim()

  if (trimmed === '') {
    return false
  }

  if (isFlowEditorNewlyAddedStepId(trimmed)) {
    return false
  }

  return true
}

export function isPersistedConfig(config: { serverId?: string }): boolean {
  return isPersistedServerId(config.serverId)
}

export function isPersistedStep(step: { serverId?: string }): boolean {
  return isPersistedServerId(step.serverId)
}
